import React from 'react';
import { Check, Palette } from 'lucide-react';
import { Button } from '../Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../DropdownMenu';
import { cn } from '../../lib/utils';
import { ACCENTS, useAccent } from '../../hooks/useAccent';

const ACCENT_LABELS = {
  blue: 'Blue',
  teal: 'Teal',
  violet: 'Violet',
  amber: 'Amber',
  green: 'Green',
};

/**
 * Header control for the accent preset. Swatch colours come from the preset's
 * --ring token (see themeAccent.css), never from component styles.
 */
function AccentPicker({ className }: { className?: string }) {
  const [accent, setAccent] = useAccent();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn('mobile:px-2 text-white hover:bg-[#1a1a1a]', className)}
          aria-label="Accent color"
          title="Accent color"
          data-cy="accent-picker"
        >
          <Palette className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {ACCENTS.map(option => (
          <DropdownMenuItem
            key={option}
            onSelect={() => setAccent(option)}
            className="flex items-center gap-2 py-2"
            data-cy={`accent-${option}`}
          >
            <span
              data-accent-preview={option}
              className="bg-ring h-3.5 w-3.5 shrink-0 rounded-full"
            />
            <span className="flex-1">{ACCENT_LABELS[option]}</span>
            <Check className={cn('h-4 w-4', option !== accent && 'invisible')} />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { AccentPicker };
